import fetch from 'utils/fetch';

export const REQUEST_MEMOS = 'REQUEST_MEMOS';
export const RECEIVE_MEMOS = 'RECEIVE_MEMOS';

function requestMemos() {
  return {
    type: REQUEST_MEMOS,
  };
}

function receiveMemos(memos) {
  return {
    type: RECEIVE_MEMOS,
    payload: {
      memos,
    },
  };
}

export function fetchMemos() {
  return dispatch => {
    dispatch(requestMemos());
    fetch('/memos.json')
      .then(res => res.json())
      .then(memos => dispatch(receiveMemos(memos)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/memo.js